import styled from 'styled-components';

const Coin = styled.div`
    display: inline-block;
    border-radius: 50%;
    border: 2px solid #fbbc05;
    background: #ffd256;
    width: 16px;
    height: 16px;
`;

export default Coin;